import axiosInstance from "./axiosInstance";

const createPromoCode = (promoCodeObj) =>
    axiosInstance.post(
        `/promo_codes`, { promo_code: promoCodeObj }
    );

const getPromoCode = (promoCodeString) =>
    axiosInstance.get(`promo_codes/${promoCodeString}`);

const getUsedPromoCodesPerUser = () => axiosInstance.get(`/promo_codes/user`);

const createForeignPartnerBooking = (bookingId, foreignPartnerBooking) => axiosInstance.post(`/bookings/${bookingId}/foreign_partner_booking`, {
    foreignPartnerBooking,
});

const setAffiliatePrice = (bookingId, affiliatePrice) => axiosInstance.put(`/bookings/${bookingId}/set_booking_affiliate_price`, {
    affiliatePrice,
});

const getForeignPartnerBooking = (bookingId) => axiosInstance.get(`/bookings/${bookingId}/get_foreign_partner_booking`)

export {
    createPromoCode,
    getPromoCode,
    getUsedPromoCodesPerUser,
    createForeignPartnerBooking,
    getForeignPartnerBooking,
    setAffiliatePrice
};